import React, { createContext, useState, useContext, useEffect } from 'react';
import authService from '../services/authService';
import userService from '../services/userService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const initAuth = async () => {
      const token = localStorage.getItem('journi_token');
      const savedUser = authService.getCurrentUser();

      if (token && savedUser) {
        const result = await userService.getProfile();
        
        if (result.success) {
          setUser(result.data.user);
          setIsAuthenticated(true);
        } else {
          authService.logout();
          setUser(null);
          setIsAuthenticated(false);
        }
      }
      
      setLoading(false);
    };

    initAuth();
  }, []);

  const login = async (phone, password) => {
    const result = await authService.login(phone, password);
    
    if (result.success) {
      setUser(result.data.user);
      setIsAuthenticated(true);
      return { success: true };
    }
    
    return { success: false, error: result.error };
  };

  const signup = async (data) => {
    const result = await authService.signup(data);
    return result;
  };

  const sendOTP = async (phone) => {
    return await authService.sendOTP(phone);
  };

  const verifyOTP = async (phone, otp) => {
    const result = await authService.verifyOTP(phone, otp);
    
    if (result.success) {
      setUser(result.data.user);
      setIsAuthenticated(true);
      return { success: true };
    }
    
    return { success: false, error: result.error };
  };

  const logout = () => {
    authService.logout();
    setUser(null);
    setIsAuthenticated(false);
  };

  const updateProfile = async (data) => {
    const result = await userService.updateProfile(data);
    
    if (result.success) {
      setUser(result.data.user);
      return { success: true };
    }
    
    return { success: false, error: result.error };
  };

  const refreshUser = async () => {
    const result = await userService.getProfile();
    
    if (result.success) {
      setUser(result.data.user);
    }
  };

  const value = {
    user,
    loading,
    isAuthenticated,
    login,
    signup,
    sendOTP,
    verifyOTP,
    logout,
    updateProfile,
    refreshUser
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  
  return context;
};

export default AuthContext;